import React from 'react';
import { NavLink } from 'react-router-dom';
import Button from '../@base/Button';

/**
 * Botão de volta para tela de seleção dos bots
 * @param show Defini se o botão vai ser exibido
 * @param botName Nome do bot
 */
export function BackToBotsButton(props) {
  if (!props.show) { return <></>; }
  return (
    <div className="title">
      <NavLink to="/bots">
        <Button small circle>
          <i className="fa fa-angle-left" aria-hidden="true" />
        </Button>
      </NavLink>
      <span>
        {props.botName}
      </span>
    </div>
  );
}

export default BackToBotsButton;
